module.exports = __webpack_public_path__ + "static/media/add_clients_card_1.14590f50.svg";